export default {
  title: 'Request Formatting',
  img: 'formatting',
  subsections: [
    {
      title: 'Authentication',
      content: [
        {
          tag: 'p',
          content: `When the Master Administrator for an organization submits a request for access to the BreeziPro PWA, an Api Key with
          the default limits and throttling, as outlined in the Limits and Data Collection section of this documentation. This key will
          serve as your Authorization and Authentication asset throughout your interaction with the listed services, and acts as a direct
          reference to your organization in Breezi’s database. In order to make calls to the vast majority of the documented API services,
          the API Key must be included as the <b>x-api-key</b> header of each request. It is also important to ensure that the <b>Content
          Type</b> header is set to “application/json,” as every response from the API will be returned in JSON format.`
        },
        {
          tag: 'highlight',
          content: 'The request headers should be formatted as follows:'
        },
        {
          tag: 'code',
          content: JSON.stringify({"Content-Type": "application/json","x-api-key": "{yourApiKey}"}, null, 3)
        }
      ]
    },
    {
      title: 'API URL',
      content: [
        {
          tag: 'p',
          content: 'The base url to access the BreeziPro Commercial API is:'
        },
        {
          tag: 'ul',
          content: [colorfyURL('https://api-pro.breezi.net')]
        },
        {
          tag: 'p',
          content: 'In order to return usable datasets, it is necessary to use url Path Parameters to specify entities within Breezi’s database and follow the <b>Query Flow</b> as outlined in the next section:'
        },
        {
          tag: 'ul',
          content: [colorfyURL('https://api-pro.breezi.net/{resourceName}/{entityId}')]
        },
        {
          tag: 'p',
          content: 'For example, if you are trying to get measurement data for an AirPulse device installed in one of your properties, a GET request can be sent to:'
        },
        {
          tag: 'ul',
          content: [colorfyURL('https://api-pro.breezi.net/measurements/AP000000')]
        },
        {
          tag: 'p',
          content: 'Or, if you wanted all of the most recent readings for all of the devices (up to 25) installed in a given building, a GET request would be sent to:'
        },
        {
          tag: 'ul',
          content: [colorfyURL('https://api-pro.breezi.net/snapshot/3141-5926-5358-9793')]
        },
        {
          tag: 'p',
          content: 'Where "3141-5926-5358-9793" is the Unique Building Id'
        },
      ]
    },
    {
      title: 'Unique Ids',
      content: [
        {
          tag: 'p',
          content: 'Some services require the use of URL Path Parameters to specify the unique values used by the Breezi Server to identify the entities they represent in the database (db). These ids will correlate to either:'
        },
        {
          tag: 'ul',
          content: ['AirPulse Serial Numbers', 'Unique Building Ids']
        },
        {
          tag: 'p',
          content: 'These parameters are used to indicate to the API that data should be returned regarding a particular db entity. This prevents the user from being inundated with enormous or irrelevant datasets and ensures optimal performance of the BreeziPro Commercial API.'
        },
        {
          tag: 'p',
          content: 'Typically, a service that seeks to provide information about the conditions measured by an array of devices over a short period of time will use the <b>Unique Building Id</b> Path Parameter, whereas queries regarding long-term data for a single point of measurement (Datapoint) will require the inclusion of an <b>AirPulse Serial Number</b>. More information about acquiring the values for these parameters is outlined in the next section of this documentation: <b>Parameters & Query Flow</b>.'
        }
      ]
    }
  ]
}

function colorfyURL(url){
  let base = '<b><span style="color:rgb(80, 142, 68)">https://api-pro.breezi.net</span>'
  url = url.replace('https://api-pro.breezi.net', '');
  if (url.length) {
    let pparams = url.split('/');
    let qparams = '';
    let lparam = pparams[pparams.length - 1];
    if (lparam.includes('?')) {
      qp = lparam.split('?');
      lparam = lparam.replace('?' + qp, '');
      qparams = qp.includes('&') ? '?' + qp.split('&').map(q => `<span style="color:purple">${q}</span>`).join('&') : `<span style="color:purple">${qp}</span>`;
    }
    base += pparams.map(p => `<span style="color:rgb(194, 139, 17)">${p}</span>`).join('/') + qparams;
  }
  base += '</b>';
  return base;
}



// WEBPACK FOOTER //
// ./src/lib/apiDocTemplates/formatting.js